/* ═══════════════════════════════════════════════════════
   JANVS.IT — WHOLESALE VINTAGE
   Main JavaScript · GSAP Scroll Animations
   Inspired by tiwis.fr transitions
═══════════════════════════════════════════════════════ */

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

/* ════════════════════════════════════
   SCROLL PROGRESS BAR
════════════════════════════════════ */
var progressBar = document.createElement('div');
progressBar.id = 'scroll-progress';
document.body.prepend(progressBar);

window.addEventListener('scroll', function() {
  var scrollTop = window.scrollY;
  var docHeight = document.documentElement.scrollHeight - window.innerHeight;
  var pct = (scrollTop / docHeight) * 100;
  progressBar.style.width = pct + '%';
});

/* cursor rimosso */

/* ════════════════════════════════════
   PARALLAX — MOUSE MOVES BACKGROUND
════════════════════════════════════ */
var pbg1  = document.getElementById('pbg1');
var pbg2  = document.getElementById('pbg2');
var pbg3  = document.getElementById('pbg3');
var HW = window.innerWidth  / 2;
var HH = window.innerHeight / 2;

document.addEventListener('mousemove', function(e) {
  var dx = (e.clientX - HW) / HW;
  var dy = (e.clientY - HH) / HH;
  gsap.to(pbg1, { x: dx * -38, y: dy * -28, duration: 1.4, ease: 'power2.out' });
  gsap.to(pbg2, { x: dx *  22, y: dy *  18, duration: 1.1, ease: 'power2.out' });
  gsap.to(pbg3, { x: dx * -14, y: dy * -10, duration:  .9, ease: 'power2.out' });
  gsap.to('#parallax-bg', { x: dx * 8, y: dy * 6, duration: 1.6, ease: 'power2.out' });
});

/* image follower rimosso */

/* ════════════════════════════════════
   SMOOTH ANCHOR SCROLL
════════════════════════════════════ */
document.querySelectorAll('a[href^="#"]').forEach(function(link) {
  link.addEventListener('click', function(e) {
    var target = document.querySelector(link.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    gsap.to(window, {
      scrollTo: { y: target, offsetY: 64 },
      duration: 1.2,
      ease: 'power3.inOut'
    });
  });
});

/* ════════════════════════════════════
   LOADER
════════════════════════════════════ */
var pctEl  = document.getElementById('ld-pct');
var progEl = document.getElementById('ld-prog');
if (window.location.pathname === '/' || window.location.pathname === '/it/' || window.location.pathname === '/it-eu/') {
var loaderTL = gsap.timeline({
  onComplete: function() {
    gsap.to('#wipe', {
      scaleY: 1,
      duration: .55,
      ease: 'power4.inOut',
      onComplete: function() {
        document.getElementById('loader').style.display = 'none';
        gsap.to('#wipe', {
          scaleY: 0,
          transformOrigin: 'bottom',
          duration: .5,
          ease: 'power4.inOut',
          delay: .05,
          onStart: function() {
            gsap.to(['#nav', '#hero'], { opacity: 1, duration: .4, stagger: .06 });
          }
        });
        launchHero();
      }
    });
  }
}); 

loaderTL
  .to('#ld-ey',   { opacity: 1, duration: .5, ease: 'power2.out' })
  .to('#ld-word', { y: 0, duration: .9, ease: 'power4.out' }, '-=.2')
  .to(progEl,     { width: '100%', duration: 1.2, ease: 'power2.inOut' }, '-=.3')
  .to({ p: 0 },   {
    p: 100,
    duration: 1.2,
    ease: 'power2.inOut',
    onUpdate: function() { pctEl.textContent = Math.round(this.targets()[0].p) + '%'; }
  }, '<')
  .to('#loader',  { opacity: 0, duration: .4, delay: .2 });

  }
  else {
  document.getElementById('loader').style.display = 'none';
}

/* ════════════════════════════════════
   HERO LAUNCH — LETTERS FALL FROM TOP
════════════════════════════════════ */
function launchHero() {
  var rows = [
    { el: '#hr1', delay: 0    },
    { el: '#hr2', delay: .18  },
    { el: '#hr3', delay: .36  }
  ];
  rows.forEach(function(r) {
    gsap.to(r.el, { y: 0, duration: 1.0, ease: 'power4.out', delay: r.delay });
  });

  var cntEl = document.getElementById('cnt-main');
  gsap.to({ v: 0 }, {
    v: 500,
    duration: 1.6,
    ease: 'power2.out',
    delay: .8,
    onUpdate: function() { cntEl.textContent = Math.round(this.targets()[0].v) + '+'; }
  });

  initScrollAnimations();
}

/* ════════════════════════════════════
   SCROLL ANIMATIONS
════════════════════════════════════ */
function initScrollAnimations() {


  /* Section dividers — line expand */
  document.querySelectorAll('.sdiv-line').forEach(function(el) {
    gsap.from(el, {
      scaleX: 0,
      transformOrigin: 'left',
      duration: 1.1,
      ease: 'power2.out',
      scrollTrigger: { trigger: el, start: 'top 88%' }
    });
  });

  /* Manifesto title — staggered word reveal with skew */
  ScrollTrigger.create({
    trigger: '#manifesto',
    start: 'top 68%',
    once: true,
    onEnter: function() {
      ['mft-a', 'mft-b', 'mft-c'].forEach(function(id, i) {
        gsap.from('#' + id, {
          y: 60,
          opacity: 0,
          skewY: 4,
          duration: .9,
          ease: 'power4.out',
          delay: i * 0.16
        });
      });
    }
  });

  /* HOW cols */
  gsap.from('.how-col', {
    y: 50,
    opacity: 0,
    stagger: .14,
    duration: .85,
    ease: 'power3.out',
    scrollTrigger: { trigger: '#how', start: 'top 85%', toggleActions: 'play none none none' }
  });

  /* Ensure how-cols are visible if already in viewport */
  ScrollTrigger.create({
    trigger: '#how',
    start: 'top bottom',
    once: true,
    onEnter: function() {
      gsap.set('.how-col', { opacity: 1, y: 0 });
    }
  });

  /* Pre-order rows slide in from left */
  gsap.from('.po-item', {
    x: -28,
    opacity: 0,
    stagger: .1,
    duration: .7,
    ease: 'power2.out',
    scrollTrigger: { trigger: '.po-list', start: 'top 78%' }
  });

  /* Mystery floater parallax on scroll */
  gsap.to('.myst-big-bg', {
    y: -50,
    ease: 'none',
    scrollTrigger: { trigger: '#mystery', start: 'top bottom', end: 'bottom top', scrub: true }
  });

  /* About image subtle scale on scroll */
  gsap.fromTo('.abt-img-wrap', { scale: 1.0 }, {
    scale: 1.04,
    ease: 'none',
    scrollTrigger: { trigger: '#about', start: 'top bottom', end: 'bottom top', scrub: true }
  });

  /* Footer logo reveal */
  gsap.from('.ft-logo', {
    letterSpacing: '.04em',
    opacity: 0,
    duration: 1.2,
    ease: 'power2.out',
    scrollTrigger: { trigger: 'footer', start: 'top 88%' }
  });

  /* ── TIWIS.FR STYLE: Section wipe transitions ── */
  /* Each major section gets a subtle background shift on scroll */
  var sections = document.querySelectorAll('section');
  sections.forEach(function(section) {
    gsap.fromTo(section, 
      { opacity: 0.85 },
      {
        opacity: 1,
        duration: .6,
        ease: 'power2.out',
        scrollTrigger: {
          trigger: section,
          start: 'top 80%',
          toggleActions: 'play none none reverse'
        }
      }
    );
  });

  /* ── Large text scale on scroll (tiwis.fr style) ── */
  gsap.fromTo('.mf-big', 
    { scale: 0.96, opacity: 0 },
    {
      scale: 1,
      opacity: 1,
      duration: 1.0,
      ease: 'power3.out',
      scrollTrigger: { trigger: '.mf-big', start: 'top 80%' }
    }
  );

  /* ── Horizontal intro panel text animation ── */
  gsap.from('.hg-intro-title', {
    y: 40,
    opacity: 0,
    duration: .9,
    ease: 'power3.out',
    scrollTrigger: { trigger: '.hg-intro', start: 'top 75%' }
  });

  gsap.from('.hg-intro-sub', {
    y: 20,
    opacity: 0,
    duration: .8,
    delay: .2,
    ease: 'power2.out',
    scrollTrigger: { trigger: '.hg-intro', start: 'top 75%' }
  });
}

/* ════════════════════════════════════
   NAV SCROLL STATE
════════════════════════════════════ */
window.addEventListener('scroll', function() {
  document.getElementById('nav').classList.toggle('scrolled', window.scrollY > 80);
});

/* ════════════════════════════════════
   COUNTDOWN
════════════════════════════════════ */
(function countdown() {
  var elD = document.getElementById('mcd-d');
  var elH = document.getElementById('mcd-h');
  var elM = document.getElementById('mcd-m');
  var elS = document.getElementById('mcd-s');
  if (!elD || !elH || !elM || !elS) return;
  var target = new Date();
  target.setDate(target.getDate() + 89);
  setInterval(function() {
    var diff = target - new Date();
    if (diff < 0) return;
    var d = Math.floor(diff / 86400000),
        h = Math.floor((diff % 86400000) / 3600000),
        m = Math.floor((diff % 3600000) / 60000),
        s = Math.floor((diff % 60000) / 1000);
    elD.textContent = String(d).padStart(2, '0');
    elH.textContent = String(h).padStart(2, '0');
    elM.textContent = String(m).padStart(2, '0');
    elS.textContent = String(s).padStart(2, '0');
  }, 1000);
})();

/* ════════════════════════════════════
   TEXT DISTORT on hover (titoli grandi)
════════════════════════════════════ */
document.querySelectorAll('.how-title, .po-big, .myst-title, .abt-title').forEach(function(el) {
  el.addEventListener('mouseenter', function() {
    gsap.to(el, { skewX: -3, scaleX: 1.02, duration: .35, ease: 'power2.out' });
  });
  el.addEventListener('mouseleave', function() {
    gsap.to(el, { skewX: 0, scaleX: 1, duration: .55, ease: 'elastic.out(1,.4)' });
  });
});

/* ════════════════════════════════════
   MYSTERY FORM SUBMIT
════════════════════════════════════ */
var mystForm = document.querySelector('.myst-form');
if (mystForm) {
  mystForm.querySelector('button').addEventListener('click', function() {
    var input = mystForm.querySelector('input');
    if (input.value && input.value.includes('@')) {
      gsap.to(mystForm, {
        scale: 1.02,
        duration: .15,
        yoyo: true,
        repeat: 1,
        ease: 'power2.out',
        onComplete: function() {
          mystForm.innerHTML = '<div style="padding:13px 18px;font-family:var(--mono);font-size:.54rem;color:var(--red);letter-spacing:.1em;">✓ ISCRITTO — TI AVVISEREMO AL LANCIO</div>';
        }
      });
    }
  });
}

/* ════════════════════════════════════
   TICKER PAUSE ON HOVER
════════════════════════════════════ */
if (window.innerWidth > 768) {
  var ticker = document.querySelector('.tk-t');
  if (ticker) {
    ticker.addEventListener('mouseenter', function() {
      ticker.style.animationPlayState = 'paused';
    });
    ticker.addEventListener('mouseleave', function() {
      ticker.style.animationPlayState = 'running';
    });
  }
}

/* ════════════════════════════════════
   MOBILE BURGER MENU
════════════════════════════════════ */
var burger = document.getElementById('nav-burger');
var mobileMenu = document.getElementById('mobile-menu');

if (burger && mobileMenu) {
  burger.addEventListener('click', function() {
    burger.classList.toggle('open');
    mobileMenu.classList.toggle('open');
    document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
  });

  document.querySelectorAll('.mm-link').forEach(function(link) {
    link.addEventListener('click', function() {
      burger.classList.remove('open');
      mobileMenu.classList.remove('open');
      document.body.style.overflow = '';
    });
  });
}

/* ════════════════════════════════════
   RESIZE HANDLER
════════════════════════════════════ */
window.addEventListener('resize', function() {
  HW = window.innerWidth  / 2;
  HH = window.innerHeight / 2;
  ScrollTrigger.refresh();
});
